import {
  bumpDashboardDataRevision,
  dashboardNeedsRefresh,
  invalidateDashboardHomeCaches,
  readDashboardDataRevision,
  shouldRefreshDashboardData,
  subscribeDashboardDataRevision,
} from './dashboardRefreshCoordinator';

const BOOKING_MUTATION_EVENT = 'roomnexa:booking-mutated';
const BOOKING_MUTATION_STORAGE_KEY = 'roomnexa:booking-mutated';

export {
  invalidateDashboardHomeCaches,
  readDashboardDataRevision,
  shouldRefreshDashboardData,
  subscribeDashboardDataRevision,
  bumpDashboardDataRevision,
};

/** @deprecated Use readDashboardDataRevision / shouldRefreshDashboardData */
export function readLastBookingMutation() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(BOOKING_MUTATION_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** @deprecated Use dashboardNeedsRefresh */
export function peekPendingDashboardMutationRefresh() {
  return dashboardNeedsRefresh();
}

/** @deprecated No-op; revision tracks freshness */
export function markBookingMutationHandled() {}

export function shouldRefreshDashboardForMutation() {
  return dashboardNeedsRefresh();
}

export const notifyBookingMutation = (details = {}) => {
  if (typeof window === 'undefined') return;

  const payload = {
    ...details,
    timestamp: Date.now(),
    revision: bumpDashboardDataRevision(details.type || 'booking'),
  };

  window.dispatchEvent(new CustomEvent(BOOKING_MUTATION_EVENT, { detail: payload }));

  try {
    window.localStorage.setItem(BOOKING_MUTATION_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }
};

export const subscribeBookingMutation = (callback) => {
  if (typeof window === 'undefined') return () => {};

  const handleMutation = (event) => {
    callback(event.detail || {});
  };

  const handleStorage = (event) => {
    if (event.key !== BOOKING_MUTATION_STORAGE_KEY || !event.newValue) return;
    try {
      callback(JSON.parse(event.newValue));
    } catch {
      callback({});
    }
  };

  window.addEventListener(BOOKING_MUTATION_EVENT, handleMutation);
  window.addEventListener('storage', handleStorage);

  return () => {
    window.removeEventListener(BOOKING_MUTATION_EVENT, handleMutation);
    window.removeEventListener('storage', handleStorage);
  };
};
